// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /chat/get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeChatGetBody,
  typeChatGetOutput200,
} from "../../sdk/chat/postChatGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildChatGetQueryKey(payload: typeChatGetBody): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`chatId:${JSON.stringify(payload.chatId)}`);
  return ["post:chat:chatGet", "svc:messaging-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<typeChatGetOutput200, unknown, typeChatGetOutput200, string[]>
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useChatGet(
  payload: typeChatGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildChatGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postChatGet(payload),
    ...resolvedOptions,
  });
}
